import { Reducer } from "redux";

import { FilteredAirlinesWidgetAction, FilteredAirlinesWidgetActionTypes, FilteredAirlinesWidgetState } from "./types";

const initialSate: FilteredAirlinesWidgetState = {
  items: [],
  isLoading: false,
};

const reducer: Reducer<FilteredAirlinesWidgetState, FilteredAirlinesWidgetAction> = (state = initialSate, action) => {
  switch (action.type) {
    case FilteredAirlinesWidgetActionTypes.FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }

    case FilteredAirlinesWidgetActionTypes.FETCH_ERROR: {
      return { ...state, isLoading: false };
    }

    case FilteredAirlinesWidgetActionTypes.FETCH_SUCCESS: {
      const { lastUpdated, items } = action.payload;
      return { ...state, isLoading: false, lastUpdated, items };
    }

    default:
      return state;
  }
};

export default reducer;
